import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardPhotoFooterStyles } from './styles/property-card-photo-footer.styles';
import type { PropertyCardPhotoFooterPropsInterface } from './types/property-card-photo-footer.types';

/*
 * A container that appears at the bottom of a property photo in a `PropertyCard`.
 * Usually contains a `PropertyCard.MLSLogo`.
 *
 * @since 8.63.0
 */
export const PropertyCardPhotoFooter = forwardRef<
  HTMLDivElement,
  PropertyCardPhotoFooterPropsInterface
>((props: PropertyCardPhotoFooterPropsInterface, forwardedRef) => {
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(propertyCardPhotoFooterStyles, cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.PhotoFooter"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_property-card__photo-footer', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardPhotoFooter.displayName = 'PropertyCard.PhotoFooter';
